import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatIconModule } from '@angular/material/icon';
import { EffectsModule } from '@ngrx/effects';
import { TranslocoDirective, TranslocoPipe } from '@ngneat/transloco';
import { ZefDialogModule } from '@zerops/zef/dialog';
import { ZefProgressErrorModule } from '@zerops/zef/progress-error';
import { ZefFormFieldModule, ZefFormsModule } from '@zerops/zef/forms';
import { ZefScrollbarComponent } from '@zerops/zef/scrollbar';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiTipCardComponent } from '@zerops/zui/tip-card';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { ZuiThreeDotsModule } from '@zerops/zui/three-dots';
import { ProgressSpinnerModule } from '@zerops/zui/progress-spinner';
import { ConfirmPopComponent } from '@zerops/zui/confirm-pop';
import { DynamicPopAnchorModule } from '@zerops/zui/dynamic-pop-anchor';
import { TokenPrimaryRoleSelectorComponent } from '@zerops/zui/token-primary-role-selector';
import { ProjectAccessOverrideComponent } from '@zerops/zui/project-access-override';
import { TokenAddEditDialogFeature } from './token-add-edit-dialog.feature';
import { TokenAddEditDialogEffect } from './token-add-edit-dialog.effect';

@NgModule({
  declarations: [ TokenAddEditDialogFeature ],
  imports: [
    CommonModule,
    EffectsModule.forFeature([ TokenAddEditDialogEffect ]),
    ZefDialogModule,
    ZefScrollbarComponent,
    FormSectionModule,
    ReactiveFormsModule,
    MatLegacyButtonModule,
    MatLegacyFormFieldModule,
    MatLegacyInputModule,
    MatIconModule,
    TranslocoDirective,
    TranslocoPipe,
    ZefProgressErrorModule,
    ZefFormFieldModule,
    ZefFormsModule,
    ZuiTipCardComponent,
    ZuiSeparatorComponent,
    ZuiThreeDotsModule,
    ProgressSpinnerModule,
    ConfirmPopComponent,
    DynamicPopAnchorModule,
    TokenPrimaryRoleSelectorComponent,
    ProjectAccessOverrideComponent
  ],
  exports: [ TokenAddEditDialogFeature ]
})
export class TokenAddEditDialogModule {}
